import Ps from 'perfect-scrollbar';

class MegaMenu {
    constructor(context, settings, $, debounce) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;
        this.$window = this.$(window);
        this.mobileBreakpoint = 900;

        this.$megaMenu = this.$('.js-mega-menu', this.context).once();
        this.$megaMenuInner = this.$('.js-mega-menu-inner', this.context).once();
        this.$megaMenuGradient = this.$('.js-mega-menu-gradient', this.context).once();
        this.$megaMenuExpandButton = this.$('.js-mega-menu-expand', this.context).once();
        this.$subNavToggle = this.$('.js-mega-menu-sub-nav-toggle', this.context).once();
        this.$mainNavItem = this.$('.js-main-nav-list-link', this.context).once();

        this.$subNavToggle.on('click', $.proxy(this.toggleOpen, this));
        this.$megaMenuExpandButton.on('click', $.proxy(this.expandMenu, this));

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];

        if (!this.$('html').hasClass('no-classlist')) {
            this.addScrollbars();

            // On load init the scrollbars
            this.$window.on('load', () => {
                if (this.$window.width() > this.mobileBreakpoint) {
                    this.addScrollbars();
                }
            });

            this.$window.on('resize', this.$.proxy(this.updateScrollbars, this));

            this.$window.on('load resize', debounce(() => {
                if (this.$window.width() <= this.mobileBreakpoint) {
                    this.destroyScrollbars();
                }
            }, 300));

            this.$mainNavItem.hover(() => {
                this.updateScrollbars();
            });

            this.toggleGradient();
        }
    }

    toggleOpen(e) {
        const $elem = this.$(e.currentTarget);

        $elem.toggleClass('is-clicked');

        if (!$elem.hasClass('is-clicked')) {
            $elem.next('.js-mega-menu-sub-nav').slideUp();
        } else {
            $elem.next('.js-mega-menu-sub-nav').slideDown();
        }
    }

    addScrollbars() {
        for (let i = 0; i < this.$megaMenuInner.length; i++) {
            this.scrollbars.push(new Ps(this.$megaMenuInner[i], {
                wheelSpeed: 0.3,
                scrollYMarginOffset: 24
            }));
        }
    }

    updateScrollbars() {
        this.scrollbars.forEach((ps) => ps.update());

        this.resetGradient();
    }

    destroyScrollbars() {
        this.scrollbars.forEach((ps) => ps.destroy());
    }

    toggleGradient() {
        this.$megaMenuInner.each((i, el) => {
            const $gradient = this.$(el).next('.js-mega-menu-gradient');

            // Hide the gradient if scrolled to the bottom
            el.addEventListener('ps-y-reach-end', () => {
                $gradient.addClass('is-hidden');
            });

            // Show the gradient if you've reached the bottom and then you scroll back up
            el.addEventListener('ps-scroll-up', () => {
                if ($gradient.hasClass('is-hidden')) {
                    $gradient.removeClass('is-hidden');
                }
            });
        });
    }

    resetGradient() {
        this.$megaMenuGradient.removeClass('is-hidden');
    }

    expandMenu(e) {
        const $elem = this.$(e.currentTarget);
        const $megaMenu = $elem.parents('.js-mega-menu');
        const $megaMenuInner = $megaMenu.find('.js-mega-menu-inner');

        // Find the height of the mega menu
        $megaMenu.scrollTop = $megaMenu.scrollHeight - $megaMenu.clientHeight;

        // Apply a class
        $megaMenu.addClass('is-expanded');

        // Scroll down on click
        $megaMenuInner.animate({scrollTop: $megaMenu.prop('scrollHeight')}, 400);

        this.updateScrollbars();
    }
}

export default MegaMenu;
